import { ActiveUserAssetFilterData, ActiveUserAssetFilterDataDTO } from './activeUserAssetsFilterData.types';

// eslint-disable-next-line import/prefer-default-export
export const parseActiveUserAssetTasksFilterDataToTableFilters = (dto: ActiveUserAssetFilterDataDTO): ActiveUserAssetFilterData =>
  dto.assets.map(({ id, name }) => ({ id, name: [name, name] }));
